import USER_ROLE from './USER_ROLE';

export default {
  [USER_ROLE.GUEST]: 1000,
  [USER_ROLE.CONTRIBUTOR]: 2000,
  [USER_ROLE.CREATOR]: 3000,
  [USER_ROLE.PRODUCER]: 4000,
  [USER_ROLE.BROADCASTER]: 5000,
  [USER_ROLE.ADMIN]: 6000,
};
